enum OEMeetingType {
  FUTURE = 'FUTURE',
  RECORDED = 'RECORDED',
}

export default OEMeetingType;
